module.exports = require('./helpers/bundle-url').getBundleURL('cGICz') + "7328.267cd791.jpg";